import Prelogin from "../services/preLoginApi";
import staticAllFunds from "../data/allFunds.json";
let api = new Prelogin();

export const fetchAllFunds = async () => {
  let apiData = []
  try {
    let payloadForFunds = {
      api_name: "FundCategoryNew",
      categoryType: "MF",
    };
    let categoryNewRes = await api.getAllFunds(payloadForFunds);
    if (categoryNewRes.data.success) {
      let getall = categoryNewRes.data?.data?.data;
      apiData = getall;
    } else {
      apiData = staticAllFunds;
    }

    return apiData
  } catch (e) {
    throw new Error("Failed to fetch funds");
  }
};
